<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="group-info">
          <div class="title-box">
            <div class="line"></div>
            <div class="title">创建分组信息</div>
          </div>
          <div class="group-input-box">
            <div class="input-box">
              <div class="label">标题</div>
              <el-input
                v-model="form.title"
                size="small"
                style="width: 500px;margin-right: 180px;"
                placeholder="请输入标题"
              ></el-input>
            </div>
            <div class="input-box">
              <div class="label">筛选器：</div>
              <el-select v-model="form.value" placeholder="请选择" size="small">
                <el-option label="并集" value="并集"> </el-option>
                <el-option label="交集" value="交集"> </el-option>
                <el-option label="排除" value="排除"> </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="filter-info">
          <div class="title-box" v-if="type === 1">
            <div class="line"></div>
            <div class="title">选择用户分组的筛选条件</div>
            <div class="btn" @click="addLabelGorupModal">添加标签组</div>
          </div>
          <div class="title-box" v-if="type === 2">
            <div class="line"></div>
            <div class="title">选择画像人群的筛选条件</div>
            <div class="input-box">
              <div class="label">时间：</div>
              <el-date-picker
                v-model="form.value1"
                type="date"
                size="mini"
                style="width: 160px;"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="label-group-list" v-if="type === 2">
            <div
              class="label-group-item"
              v-for="(item, index) in list"
              :key="index"
            >
              <div class="label-group-info">
                <div class="label-group-title">
                  <i class="el-icon-document icon"></i>
                  用户基础信息标签组
                  <div class="input-box">
                    <el-select
                      v-model="form.value"
                      placeholder="请选择"
                      size="mini"
                      style="width: 100px;"
                    >
                      <el-option label="并集" value="并集"> </el-option>
                      <el-option label="交集" value="交集"> </el-option>
                      <el-option label="排除" value="排除"> </el-option>
                    </el-select>
                  </div>
                  <div class="input-box">
                    <div class="label">时间：</div>
                    <el-date-picker
                      v-model="form.value1"
                      type="date"
                      size="mini"
                      style="width: 120px;"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </div>
                  <div style="flex: 1"></div>
                  <div class="add-plate">
                    <i class="el-icon-circle-plus"></i>
                    添加板块
                  </div>
                </div>
                <div class="plate-list">
                  <div
                    class="plate-item"
                    v-for="(plateItem, plateIndex) in 5"
                    :key="plateIndex"
                  >
                    <div class="plate-left">
                      <el-select
                        v-model="form.value"
                        placeholder="请选择"
                        size="mini"
                        style="width: 200px;"
                      >
                        <el-option label="并集" value="并集"> </el-option>
                        <el-option label="交集" value="交集"> </el-option>
                        <el-option label="排除" value="排除"> </el-option>
                      </el-select>
                    </div>
                    <div class="plate-right">
                      <!-- <el-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="checkAll"
                        @change=""
                        >全选</el-checkbox
                      >
                      <el-checkbox-group v-model="checkedCities" @change="">
                        <el-checkbox
                          v-for="city in cities"
                          :label="city"
                          :key="city"
                          >{{ city }}</el-checkbox
                        >
                      </el-checkbox-group> -->
                      <div class="select-box" @click="selectProductModal({checkList: []})">
                        <div>
                          <span v-if="1">
                            已选{{ 1 }}种产品
                          </span>
                          <span v-else>
                            请选择产品
                          </span>
                        </div>
                        <div class="add">
                          选择产品
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="btn-box">
                <div class="btn">添加下层筛选条件</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="添加标签组"
      width="300px"
      :visible.sync="labelGroupVisible"
    >
      <div class="label-group-box">
        <el-radio v-model="form.radio" label="1">用户基础信息标签</el-radio>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="labelGroupVisible = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="addLabelGorup"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="selectProductVisible"
      class="dialog"
      width="1150px"
      top="10vh"
    >
      <div slot="title" class="dialog-title">
        多选产品
      </div>
      <div class="select-product-box">
        <div class="filter-box">
          <div class="label" style="margin-left: 0;">产品ID：</div>
          <el-input
            v-model="productForm.id"
            placeholder="产品ID"
            style="width: 120px;"
            size="small"
          ></el-input>
          <div class="label">关键字：</div>
          <el-input
            v-model="productForm.name"
            placeholder="关键字"
            style="width: 200px;"
            size="small"
          ></el-input>
          <div class="label">价格：</div>
          <el-input
            v-model="productForm.minPrice"
            placeholder=""
            style="width: 80px;"
            size="small"
          ></el-input>
          <div style="margin: 0 5px;">至</div>
          <el-input
            v-model="productForm.maxPrice"
            placeholder=""
            style="width: 80px;"
            size="small"
          ></el-input>
          <div style="margin: 0 5px;">元</div>
          <div class="search" @click="getGoodsList">搜索</div>
          <div class="reset" @click="resetProduct">重置</div>
        </div>
        <div class="product-list-box">
          <div class="list-left">
            <div class="list-top">
              <el-checkbox
                v-model="selectAll"
                style="margin-right: 6px;"
                @change="handleChangeAll"
              ></el-checkbox>
              选中当前页
            </div>
            <div class="product-list" :key="timeStemp">
              <div
                class="item"
                v-for="(item, index) in productList"
                :key="index"
              >
                <el-checkbox
                  :value="selectedObj[item.id]"
                  @change="(e) => changeSelected(e, item)"
                ></el-checkbox>
                <img :src="item.masterPic" alt="" class="pic" />
                <div class="product-info">
                  <div class="name">{{ item.name }}</div>
                  <div class="id">产品ID：{{ item.id }}</div>
                </div>
                <div class="price">￥{{ item.price }}</div>
              </div>
            </div>
            <div class="pagination" v-show="productList.length">
              <el-pagination
                @current-change="handleCurrentChangeProduct"
                :current-page.sync="currentPage"
                background
                layout="total, prev, pager, next, jumper"
                :page-size="size"
                :total="total"
                small
              ></el-pagination>
            </div>
          </div>
          <div style="width: 40px;text-align: center;color: #999;">>></div>
          <div class="list-right">
            <div class="list-top">
              已选择产品（{{ selectProductList.length }}）
              <span @click="emptyProduct">清空</span>
            </div>
            <div class="product-list">
              <div
                class="item"
                v-for="(item, index) in selectProductList"
                :key="index"
              >
                {{ index + 1 }}
                <img :src="item.masterPic" alt="" class="pic" />
                <div class="product-info">
                  <div class="name">{{ item.name }}</div>
                  <div class="id">产品ID：{{ item.id }}</div>
                </div>
                <div class="price">￥{{ item.price }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="selectProductVisible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="addProduct">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="selectBrandVisible"
      class="dialog"
      width="1150px"
      top="10vh"
    >
      <div slot="title" class="dialog-title">
        多选品牌
      </div>
      <div class="select-product-box">
        <div class="filter-box">
          <div class="label" style="margin-left: 0;">品牌ID：</div>
          <el-input
            v-model="brandForm.id"
            placeholder="品牌ID"
            style="width: 120px;"
            size="small"
          ></el-input>
          <div class="label">关键字：</div>
          <el-input
            v-model="brandForm.brandName"
            placeholder="关键字"
            style="width: 200px;"
            size="small"
          ></el-input>
          <div style="margin: 0 5px;">元</div>
          <div class="search" @click="getBrandList">搜索</div>
          <div class="reset" @click="resetBrand">重置</div>
        </div>
        <div class="product-list-box">
          <div class="list-left">
            <div class="list-top">
              <el-checkbox
                v-model="selectAll"
                style="margin-right: 6px;"
                @change="handleChangeAll"
              ></el-checkbox>
              选中当前页
            </div>
            <div class="product-list" :key="timeStemp">
              <div class="item" v-for="(item, index) in brandList" :key="index">
                <!-- {{ selectedObj[item.id] }} -->
                <el-checkbox
                  :value="selectedObj[item.id]"
                  @change="(e) => changeSelected(e, item)"
                ></el-checkbox>
                <img :src="item.logo" alt="" class="pic" />
                <div class="product-info">
                  <div class="name">{{ item.brandName }}</div>
                  <div class="id">品牌ID：{{ item.id }}</div>
                </div>
                <!-- <div class="price">￥{{ item.price }}</div> -->
              </div>
            </div>
            <div class="pagination" v-show="brandList.length">
              <el-pagination
                @current-change="handleCurrentChangeBrand"
                :current-page.sync="currentPage"
                background
                layout="total, prev, pager, next, jumper"
                :page-size="size"
                :total="total"
                small
              ></el-pagination>
            </div>
          </div>
          <div style="width: 40px;text-align: center;color: #999;">>></div>
          <div class="list-right">
            <div class="list-top">
              已选择品牌（{{ selectBrandList.length }}）
              <span @click="emptyBrand">清空</span>
            </div>
            <div class="product-list">
              <div
                class="item"
                v-for="(item, index) in selectBrandList"
                :key="index"
              >
                {{ index + 1 }}
                <img :src="item.logo" alt="" class="pic" />
                <div class="product-info">
                  <div class="name">{{ item.brandName }}</div>
                  <div class="id">品牌ID：{{ item.id }}</div>
                </div>
                <!-- <div class="price">￥{{ item.price }}</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="selectBrandVisible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="addBrand">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import { staticImg, AREA_OSS } from '@/config'; // oss 图片地址
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      title: {
        // 页面标题
        firstTitile: '用户画像',
        secondTitle: '用户画像'
      },
      form: {},
      content: '',
      pics: [],
      info: {},
      type: 2, // 类型


      list: [{}, {}, {}],
      labelGroupVisible: false, // 标签组弹窗


      selectProductVisible: false,
      productList: [], // 已选产品列表
      selectProductList: [],
      selectBrandVisible: false,
      brandList: [],
      selectBrandList: [],
      selectAll: false,
      selectedObj: {},
      productForm: {
        minPrice: null,
        maxPrice: null,
        name: '',
        id: null
      },
      brandForm: {
        id: null,
        brandName: ''
      },
      timeStemp: +new Date(),
      currentItem: null,
    };
  },
  mounted() {
    // 获取列表
    this.id = this.$route.query.id;
    this.getInfo();
  },
  computed: {},
  methods: {
    // 获取列表
    getInfo() {
      this.loading++;
      this.httpGet(this.$root.getFeedbackInfo, {
        id: this.id
      }).then(
        (res) => {
          this.loading--;
          this.info = res;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    addLabelGorupModal(){
        this.labelGroupVisible = true;
    },
    addLabelGorup(){
        this.labelGroupVisible = false;
        this.type = 2;
    },



    handleCurrentChangeProduct(page){
      this.currentPage = page;
      this.getGoodsList();
    },
    getGoodsList() {
      // this.loading++;
      this.httpGet(this.$root.getGoodsList, {
        page: this.currentPage,
        size: this.size,
        ...this.productForm,
        minPrice: +this.productForm.minPrice || null,
        maxPrice: +this.productForm.maxPrice || null,
        id: +this.productForm.id || null,
      }).then(
        (res) => {
          // this.loading--;
          this.productList = res.list;
          this.total = res.total;
          this.timeStemp = +new Date();
          let flag = true;
          res.list.forEach(item => {
            if(!this.selectedObj[item.id]) flag = false;
          });
          this.selectAll = res.list.length ? flag : false;
        },
        (res) => {
          // this.loading--;
          this.$message.error(res);
        }
      );
    },
    resetProduct(){
      this.productForm = {
        id: null,
        name: '',
        minPrice: null,
        maxPrice: null
      };
      this.getGoodsList();
    },
    handleCurrentChangeBrand(page){
      this.currentPage = page;
      this.getBrandList();
    },
    getBrandList() {
      // this.loading++;
      this.httpGet(this.$root.getBrandList, {
        page: this.currentPage,
        size: this.size,
        ...this.brandForm,
        id: +this.brandForm.id || null,
      }).then(
        (res) => {
          // this.loading--;
          this.brandList = res.list;
          this.total = res.total;
          this.timeStemp = +new Date();
          let flag = true;
          res.list.forEach(item => {
            if(!this.selectedObj[item.id]) flag = false;
          });
          this.selectAll = res.list.length ? flag : false;
        },
        (res) => {
          // this.loading--;
          this.$message.error(res);
        }
      );
    },
    resetBrand(){
      this.brandForm = {
        id: null,
        brandName: '',
      };
      this.getBrandList();
    },
    changeSelected(e, item){
      // console.log(e, item);
      if(this.selectProductVisible){
        this.selectedObj[item.id] = e;
        if(e) this.selectProductList.push(item);
        if(!e){
          this.selectProductList = this.selectProductList.filter(product => {
            return product.id !== item.id;
          });
        };
        let flag = true;
        this.productList.forEach(product => {
          if(!this.selectedObj[product.id]) flag = false;
        });
        this.selectAll = flag;
      };
      if(this.selectBrandVisible){
        this.selectedObj[item.id] = e;
        if(e) this.selectBrandList.push(item);
        if(!e){
          this.selectBrandList = this.selectBrandList.filter(brand => {
            return brand.id !== item.id;
          });
        };
        let flag = true;
        this.brandList.forEach(brand => {
          if(!this.selectedObj[brand.id]) flag = false;
        });
        this.selectAll = flag;
      }
    },
    handleChangeAll(e){
      if(e){
        if(this.selectProductVisible){
          this.productList.forEach(item => {
            if(!this.selectedObj[item.id]) this.selectProductList.push(item);
            this.selectedObj[item.id] = true;
          });
        };
        if(this.selectBrandVisible){
          this.brandList.forEach(item => {
            if(!this.selectedObj[item.id]) this.selectBrandList.push(item);
            this.selectedObj[item.id] = true;
          });
        };
      } else {
        if(this.selectProductVisible){
          this.productList.forEach(item => {
            // this.selectProductList.push(item);
            this.selectedObj[item.id] = false;
          });
          this.selectProductList = this.selectProductList.filter(item => {
            return this.selectedObj[item.id];
          })
        };
        if(this.selectBrandVisible){
          this.brandList.forEach(item => {
            // this.selectProductList.push(item);
            this.selectedObj[item.id] = false;
          });
          this.selectBrandList = this.selectBrandList.filter(item => {
            return this.selectedObj[item.id];
          })
        }
      }
    },
    async selectProductModal(item){
      this.currentItem = item;
      this.selectedObj = {};
      this.selectAll = false;
      this.currentPage = 1;
      this.selectProductList = [];
      if(item.checkList.length && !item.load){
        await this.getPortraitSearchName(item.checkList, 1);
      } else {
        this.selectProductList = [...item.checkList];
        item.checkList.forEach(product => {
          this.selectedObj[product.id] = true;
        })
      };

      this.getGoodsList();
      this.selectProductVisible = true;
    },
    // getProductInfoByIds(ids){
    //   this.selectProductList = [{id: 3050, name: '123'}];
    //   // this.selectedObj
    // },
    emptyProduct(){
      this.selectProductList = [];
      this.selectedObj = {};
    },
    addProduct(){
      this.selectProductVisible = false;
      if(this.currentItem){
        this.currentItem.checkList = [...this.selectProductList];
        this.currentItem.load = true;
      }
    },
    async selectBrandModal(item){
      this.currentItem = item;
      this.selectAll = false;
      this.selectedObj = {};
      this.currentPage = 1;
      this.selectBrandList = [];
      if(item.checkList.length && !item.load){
        await this.getPortraitSearchName(item.checkList, 2);
      } else {
        this.selectBrandList = [...item.checkList];
        item.checkList.forEach(brand => {
          this.selectedObj[brand.id] = true;
        })
      }
      this.getBrandList();
      this.selectBrandVisible = true;
    },
    // getBrandInfoByIds(ids){
    //   // this.selectedObj
    // },
    emptyBrand(){
      this.selectBrandList = [];
      this.selectedObj = {};
    },
    addBrand(){
      this.selectBrandVisible = false;
      if(this.currentItem){
        this.currentItem.checkList = [...this.selectBrandList];
        this.currentItem.load = true;
      }
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';
>>>.el-dialog__header{
    border-bottom: 1px solid #ebeef5;
}

.banner-box{
    height: 100%;
    flex-y(flex-start, flex-start);
    .container{
        width: 100%;
        flex: 1;
        overflow: hidden;
        .content{
            width: 100%;
            height: 100%;
            padding: 8px 10px;
            box-sizing: border-box;
            overflow: hidden;
            flex-y(flex-start, flex-start);
        }
    }
}

.title-box{
    width: 100%;
    height: 50px;
    flex-x(flex-start);
    white-space: nowrap;
    flex-shrink: 0;

    .line{
        height: 16px;
        width: 4px;
        background: #618EFF;
        margin-right: 10px;
    }
    .title{
        margin-right: 50px;
    }
    .btn{
        height: 32px;
        padding: 0 20px;
        border-radius: 4px;
        background: #5283FF;
        flex-x(center);
        word(14px, #fff);
        cursor: pointer;
    }
    .input-box{
        flex-x(flex-start);
        .label{
            word(14px, #333);

        }
    }
}

.group-info{
    width: 100%;
    background: #fff;
    flex-y(flex-start, flex-start);
    border-radius: 5px;
    padding: 0 30px;
    box-sizing: border-box;
    .group-input-box{
        flex-x(flex-start);
        padding-left: 14px;
        padding-bottom: 16px;
        .input-box{
            flex-x(flex-start);
            .label{
                margin-right: 20px;
                word(14px, #333);
                white-space: nowrap;
            }
        }
    }
}
.filter-info{
    width: 100%;
    flex: 1;
    background: #fff;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    border-radius: 5px;
    padding: 0 30px;
    box-sizing: border-box;
    margin-top: 20px;
    .title-box{
      margin-top: 15px;
    }
}
.label-group-box{
    padding: 20px 0 100px 40px;
}

.label-group-list{
    width: 100%;
    padding-left: 75px;
    margin-top: 10px;
    box-sizing: border-box;
    .label-group-item{
        .label-group-info{
            width: 100%;
            border: 1px solid #ccc;
            border-radius: 5px;
            padding: 10px 6px;
            .input-box{
                margin-left: 40px;
                flex-x(flex-start);
                .label{
                    word(14px, #333);
                }
            }
            .label-group-title{
                margin-right: 20px;
                flex-x(flex-start);
                .icon{
                    margin-right: 12px;
                    color: #5283FF;
                }
                .add-plate{
                    cursor: pointer;
                    word(14px, #333);
                    i{
                        word(12px, #5283FF);
                    }
                }
            }
            .plate-list{
                padding-left: 28px;
                .plate-item{
                    margin-top: 10px;
                    flex-x(flex-start);
                    .plate-right{
                        margin-left: 32px;
                        .select-box{
                          width: 260px;
                          height: 28px;
                          background: #F2F2F2;
                          border: 1px solid #E3E3E3;
                          border-radius: 2px;
                          flex-x();
                          padding: 0 10px;
                          box-sizing: border-box;
                          span{
                            word(14px, #333);
                          }
                          .add{
                            word(14px, #618EFF);
                            cursor: pointer;
                          }
                        }
                    }
                }
            }
        }
        .btn-box{
            height: 80px;
            flex-x(center);
            .btn{
                height: 32px;
                padding: 0 20px;
                border-radius: 4px;
                background: #5283FF;
                flex-x(center);
                word(14px, #fff);
                cursor: pointer;
            }
        }
    }
}

.select-product-box{
  .filter-box{
    flex-x(flex-start);
    .label{
      margin-right: 16px;
      margin-left: 12px;
    }
    .search{
      width: 65px;
      height: 36px;
      border-radius: 5px;
      background: #5283FF;
      border: 1px solid #5283FF;
      box-siing: border-box;
      word(14px, #fff);
      flex-x(center);
      cursor: pointer;
      margin-left: 24px;
    }
    .reset{
      width: 65px;
      height: 36px;
      border-radius: 5px;
      background: #fff;
      border: 1px solid #979797;
      box-siing: border-box;
      word(14px, #333);
      flex-x(center);
      cursor: pointer;
      margin-left: 12px;

    }
  }
  .product-list-box{
    flex-x();
    margin-top: 20px;
    margin-bottom: 20px;
    .list-left, .list-right{
      width: 550px;
      height: 480px;
      background: #F2F2F2;
      border: 1px solid #E8E8E8;
      flex-y(flex-start);
      .list-top{
        width: 100%;
        height: 32px;
        flex-x(flex-start);
        padding: 0 12px;
        box-sizing: border-box;
        border-bottom: 1px solid #E8E8E8;
        flex-shrink: 0;
        span{
          cursor: pointer;
        }
      }
      &.list-right{
        .list-top{
          width: 100%;
          flex-x();
        }
      }
      .product-list{
        width: 100%;
        box-sizing: border-box;
        flex-y(flex-start);
        padding: 0 12px;
        overflow-y: auto;
        .item{
          width: 100%;
          height: 65px;
          flex-x(flex-start);
          flex-shrink: 0;
          border-bottom: 1px dashed #D1D1D1;
          .pic{
            width: 44px;
            height: 44px;
            border-radius: 2px;
            margin-left: 10px;
            margin-right: 5px;
          }
          .product-info{
            flex: 1;
            height: 36px;
            flex-y(space-between, flex-start);
          }
          .price{
            height: 36px;
            word(14px, #FF8D1A);
            flex-y(flex-end, flex-start);
          }
        }
      }
      .pagination{
        width: 100%;
        height: 36px;
        flex-x(flex-end);
        margin-top: 10px;
      }
    }
    .list-right{
      overflow-y: auto;
    }
  }
}
</style>
